import { graphql } from 'react-apollo';

import { AlbumForWebGalleriesPurchases } from '../../../../../../pro/views/HierarchyItem/Matches/graphql/queries/album';

const AlbumForWebGalleriesPurchasesOptions = {
  options: ({ match, albumFolderId }) => ({
    variables: {
      id: match.params.albumMembershipGroupId,
      album_folder_id: albumFolderId,
    },
    fetchPolicy: 'network-only',
  }),
  skip: ({ match }) => !match.params.albumMembershipGroupId,
};

const getAlbumForWebGalleriesPurchases = graphql(
  AlbumForWebGalleriesPurchases,
  AlbumForWebGalleriesPurchasesOptions,
);

export default getAlbumForWebGalleriesPurchases;
